import React from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { createNewMessage } from '../actions/messageActions';
import ContactCareGuidePhone from 'material-ui/svg-icons/communication/phone';
import ContactCareGuideEmail from 'material-ui/svg-icons/communication/email';
import { resourceApi } from '../utils/fetchUtil';
import { hashHistory } from 'react-router/lib';
import Chat from 'material-ui/svg-icons/communication/forum';
import {fireInAppBrowserPlugin } from '../actions/environmentActions';

class CareGuideContact extends React.Component {

    newMessage = () => {
        this.fire('chat');
        this.props.clearMessage();
        hashHistory.push('/messages');
    }

    fire(actionType){   
        let config = {
            method: 'get',
            url: `log/careGuideContact/${actionType}`
        };

        resourceApi(config);  
    }

    getContent() {
        return {__html: this.props.cgContent};
    }

    render() {


    return (
            <div style={{display:"flex", width:"100%",flexDirection:"column"}}>
                <br />
                <table>
                <tr>
                    {this.props.member.IsCareGuideActive && (
                        <td style={{width:160}}>
                            <div style={{width:100}} className="care-guide" />
                        </td>
                    )}
                    <td>
                        <div style={{flexBasis:"100%",  width:"90%", margin:"0 auto"}}>
                           
                                <div style={{display:"flex", flexDirection:"column", width:"100%"}}>
                                    {this.props.member.IsTwoWayMessagingActive && (
                                        <div style={{marginBottom:10}}>
                                            <RaisedButton style={{display:"flex", flexDirection:"column", width:"70%"}} label="Chat"  primary={true} icon={<Chat />}  onClick={this.newMessage} />
                                        </div>
                                    )}
                                    {this.props.member.CareGuideNumber && (
                                        <div>
                                            <a style={{ textDecoration:"none"}} onClick={() => {this.fire('phone'); fireInAppBrowserPlugin(`tel:${this.props.member.CareGuideNumber}`);}} >
                                                <RaisedButton style={{display:"flex", flexDirection:"column", width:"70%"}} icon={<ContactCareGuidePhone />}  primary={true} label="Call"  />
                                            </a>
                                        </div>
                                    )}
                                </div>
                       
                            {this.props.member.CareGuideEmail && (
                                <a style={{ textDecoration:"none"}} onClick={() => {this.fire('email'); fireInAppBrowserPlugin(`mailto:${this.props.member.CareGuideEmail}`)}} >
                                    <RaisedButton style={{display:"flex", flexDirection:"column", width:"70%"}} icon={<ContactCareGuideEmail />}  primary={true} label="Email" />
                                </a>
                            )}
                        </div>
                    </td>
                </tr>
            </table>
            <br />
            <br />
        </div>
    );
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearMessage: () => {
      dispatch(createNewMessage())
    }
  }
}

const mapStateToProps = (state) => ({
    member: state.thisApp.auth.member
})


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CareGuideContact)



// WEBPACK FOOTER //
// ./src/Components/CareGuideContact.js